import { AlertCircle } from 'lucide-react';

const ErrorState = ({ error, onRetry, onDismiss }) => {
  if (!error) return null;

  return (
    <div className="fixed top-4 right-4 z-[300] max-w-md animate-fadeIn">
      <div className="bg-red-900/20 border border-red-500/50 rounded-lg p-4 backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-white font-semibold text-sm mb-1">Error</h3>
            <p className="text-gray-300 text-sm">{error}</p>
          </div>
          <button
            onClick={onDismiss}
            className="text-gray-400 hover:text-white transition-colors text-xl leading-none"
            aria-label="Dismiss error"
          >
            ×
          </button>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-3 w-full bg-red-500/20 hover:bg-red-500/30 text-red-200 py-2 px-4 rounded text-sm transition-colors"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;